module.exports = __webpack_public_path__ + "static/media/username_icon2.6feefd00.svg";